var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"spinner"}},[_c('vue-loaders-ball-spin-fade-loader',{attrs:{"color":"#bd2532","scale":"1.2"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }